<template>
  <div class="container p-4">
    <client-only>
      <HeadLine />
      <template v-if="rating.isStartStep.value">
        <p v-if="rating.state.tenderData" class="font-light text-2xl mb-10">
          {{ rating.state.tenderData.description }}
        </p>
        <div>
          <label class="checkbox mb-3">
            <input
              v-model="rating.state.jobDone"
              type="radio"
              :value="true"
              :disabled="loading"
            />
            {{ $t("professionalRating.start.withJob") }}
          </label>
        </div>
        <div>
          <label class="checkbox mb-10">
            <input
              v-model="rating.state.jobDone"
              type="radio"
              :value="false"
              :disabled="loading"
            />
            {{ $t("professionalRating.start.withoutJob") }}
          </label>
        </div>
        <div class="mb-4">
          <JoszakiButton class="w-full rounded-lg text-2xl" @click="goNext()">
            {{ $t("common.next") }}
          </JoszakiButton>
        </div>
      </template>

      <AddEmail v-if="rating.isAddEmailStep.value" />

      <FailedIdentification v-if="rating.isProblemStep.value" />

      <IdentifyByPhone v-if="rating.isSmsLoginStep.value" @reset="restart" />

      <div class="mb-4">
        <JoszakiButton
          class="w-full text-2xl"
          :inverted="true"
          :outline="true"
          @click="restart"
        >
          <template v-if="rating.isProblemStep">
            {{ $t("professionalRating.backToProfile") }}
          </template>
          <template v-else>
            {{ $t("common.cancel") }}
          </template>
        </JoszakiButton>
      </div>
    </client-only>
  </div>
</template>

<router>
{
  name: 'professionalRatingPage'
}
</router>

<script>
import { mapState } from "pinia";
import { useRating } from "~/components/_refactored/rating/useRating";
import HeadLine from "~/components/_refactored/rating/HeadLine";
import AddEmail from "~/components/_refactored/rating/AddEmail.vue";
import FailedIdentification from "~/components/_refactored/rating/FailedIdentification.vue";
import IdentifyByPhone from "~/components/_refactored/rating/IdentifyByPhone.vue";
import { useUserStore } from "~/stores/user";

export default {
  name: "RatingPage",
  components: {
    HeadLine,
    AddEmail,
    FailedIdentification,
    IdentifyByPhone,
  },
  layout: "DefaultLayout",
  setup() {
    const rating = useRating();

    return {
      rating,
    };
  },
  data: () => ({
    loading: false,
  }),
  head() {
    return {
      title: this.$t("global.meta.title", {
        suffix: this.$t("professionalRating.titleSuffix"),
      }),
      meta: [
        {
          hid: this.$t("professionalRating.meta.rating.name"),
          name: this.$t("professionalRating.meta.rating.name"),
          content: this.$t("professionalRating.meta.rating.content"),
        },
        {
          name: "robots",
          content: "noindex",
        },
      ],
    };
  },
  computed: {
    ...mapState(useUserStore, {
      me: "me",
    }),
  },
  mounted() {
    this.rating.init(this.$route.params.professionalSeoName);
  },
  methods: {
    goNext() {
      this.rating.nextStep();
    },
    restart() {
      if (this.startStep || this.problemStep) {
        this.$router.push(
          this.localePath({
            name: "professionalPage",
            params: {
              professionalSeoName: this.$route.params.professionalSeoName,
            },
          })
        );
        return;
      }
      this.rating.restart();
    },
  },
};
</script>
